<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist @help="help" @add="add" @reflash="reflash"   ref="SetBtn"></buttonlist>
		<!-- <serce :isVisible="isVisible" queryData="ExchangeRateViewInfo" ref="ser" @getser="serclick"></serce> -->
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<el-table
			id="xpane-0"
			:data="datajson"
			v-loading="loading"
			:highlight-current-row="false"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			header-row-class-name="headerclass"
			:height="tableHeight"
			@cell-dblclick="editInfo"
			tab-click="selectInfo(0)"
			@selection-change="handleSelectionChange"
			style="width: 100%; margin-top:0px"
			ref="singleTable"
		>
			<el-table-column type="selection"></el-table-column>
			<!-- <el-table-column show-overflow-tooltip prop="num" label="ID" v-if="false"></el-table-column> -->
			<el-table-column show-overflow-tooltip prop="craftname" :label="$t('getapi[13222]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="unit_price" :label="$t('getapi[13223]')" align="right" width="100"></el-table-column>
			
			<el-table-column :label="$t('getapi[6048]')" width="100">
				<template slot-scope="scope">
					<el-button @click.native.prevent="edit(scope)" type="text" size="small">{{$t('getapi[34]')}}</el-button>
					<el-popconfirm :confirmButtonText="$t('getapi[6109]')" :cancelButtonText="$t('getapi[6851]')" icon="el-icon-info" iconColor="red" :title="$t('getapi[6049]')" @onConfirm="del(scope)">
						<el-button slot="reference" type="text" size="small">{{$t('getapi[40]')}}</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		
		<!-- 搜索弹框 -->
		<!-- 编辑弹框 -->
		<el-dialog v-dialogDrag :visible.sync="editvisi" :title="$t('getapi[13221]')" width="31%" :close-on-click-modal="false">
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
				<tr>
					<td>{{$t('getapi[13215]')}}</td>
					<td><el-input v-model="formInline.craftname" type="text" size="mini"></el-input></td>
					<td>{{$t('getapi[13216]')}}</td>
					<td><el-input v-model="formInline.unit_price" type="text" size="mini"></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="small"  @click="editvisi = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small"  type="primary" @click="sava">{{$t('getapi[937]')}}</el-button>
			</span>
		</el-dialog>
		<!-- 编辑弹框 -->
	</div>
</template>

<script>
import Common from '@/components/Common';
export default {
	name: 'mevtcraftprocprice',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			formInline: {
				exclusively_id:0,
				craftname:'',
				craftabbr:'',
				unit_price:'',
				createpersoncode:'',
				createpersonname:'',
				createtime:'',
				modifypersoncode:'',
				modifypersonname:'',
			},
			ids: '',
			cgzb: [],
			showloading: '',
			isVisible: false,
			editvisi: false,
			DbTbNames: '', //表名
			datajson: [],
			PageIndex: 1,
			PageSize: this.$http.getPageSize('mevtcraftprocprice'),
			SelectIndex: 1,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			dataSetDetail: {}, // 编辑页面数据详情
			queryData: [], // 查询数组
			selectData: [], // 选择的数据的ID集合
			tracetype: 0, //跟踪类别
			url: '', // 零件图路径
			isEdit: true, // 是否新增
            scrollTop:0,
		};
	},
	create() {},
	beforeMount() {
		console.log('beforeMount');
	},
    watch: {
        datajson: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted() {
		console.log('mounted');
		let that = this;
		that.intidata();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1083]"),this.$t("getapi[11]"));
        },
		//type
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			if (that.selectData.length > 0) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('create,refresh');
				} else {
					that.$refs.SetBtn.SetButtonEnable('create,refresh');
				}
			} else {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('create,refresh');
				} else {
					that.$refs.SetBtn.SetButtonEnable('create,refresh');
				}
			}
			// that.$limits.authority('plv2', 78, 1)
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
            this.$http.savePageSize('mevtcraftprocprice',val)
			this.intidata();
			this.authority();
		},
		//跳页
		handleCurrentChange(val) {
			this.PageIndex = val;
			this.intidata();
			this.authority();
		},
		//编辑
		editInfo(row) {
			let that = this;
		},
		handleSelectionChange(val) {
			let that = this;
			that.selectData = [];
			for (let i = 0; i < val.length; i++) {
				that.selectData.push(val[i]);
			}				
			console.log(that.selectData);
			that.authority();
		},
		// 获取数据
		intidata() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: 1,
				PageSize: 100000,
				Param: datac
			};
			that.$http.urlpost('Eng/MEvtManage/GetMEvtCraftProcPriceList', data, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.datajson = res.DataContent;
					that.total = res.Totals;
					that.DbTbNames = res.DbTbNames;
				}
				that.loading = false;
				that.authority();
			});
		},
		sava() {
			let that = this;
			that.loading = true;
			
			that.$http.urlpost('Eng/MEvtManage/SaveMEvtCraftProcPrice', that.formInline, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.$message.success(that.$t('getapi[3153]'));//'保存成功'
					that.editvisi = false;
					that.intidata();
				}
				that.loading = false;
			});
		},
	
		// 编辑
		edit(jsd) {			 
			this.formInline.exclusively_id= jsd.row.exclusively_id;
			this.formInline.craftname= jsd.row.craftname;
			this.formInline.craftabbr= jsd.row.craftabbr;
			this.formInline.unit_price= jsd.row.unit_price;
			this.formInline.createpersoncode= jsd.row.createpersoncode;
			this.formInline.createpersonname= jsd.row.createpersonname;
			this.formInline.createtime= jsd.row.createtime;
			this.formInline.modifypersoncode= jsd.row.modifypersoncode;
			this.formInline.modifypersonname= jsd.row.modifypersonname;
			this.editvisi = true;
		},
		// 删除
		del(jsd) {
            let that = this
           
            let parm = {
                Id:jsd.row.exclusively_id
            };
            that.$http.urlpost('Eng/MEvtManage/DeleteMEvtCraftProcPriceByID', parm, function(res) {
                console.log(res);
                if (res.Success == 1) {
                    that.$message.success(that.$t('getapi[659]'));//'删除成功'
                    that.intidata();
                }
            });
		},
		
		// 新增
		add() {
			let that = this;
			that.editvisi = true;
			that.formInline = {
				exclusively_id:0,
				craftname:'',
				craftabbr:'',
				unit_price:'',
				createpersoncode:'',
				createpersonname:'',
				createtime:'',
				modifypersoncode:'',
				modifypersonname:'',
			};
		},
		// 刷新
		reflash() {
			this.intidata();
		},
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'ExchangeRateViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.pageIndex = 1;
			this.confirmGetView();
		},
		confirmGetView() {
			let that = this;
			that.pageIndex = 1
			that.isVisible = false;
			that.intidata();
		},
	}
};
</script>

<style lang="scss" scoped>

table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
